import { render, staticRenderFns } from "./VAssetsByCountries.vue?vue&type=template&id=010b2e3c&"
import script from "./VAssetsByCountries.vue?vue&type=script&lang=js&"
export * from "./VAssetsByCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports